import ActiveFiltersQuery from '@jetshop/core/components/DynamicRoute/ActiveFiltersQuery.gql';
import FilterContainerWrapper from '@jetshop/core/components/Filters/FilterContainerWrapper';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import PaginationProvider, { usePagination } from '@jetshop/core/components/Pagination/PaginationProvider';
import throwErrorInDev from '@jetshop/core/helpers/throwErrorInDev';
import { useFilters } from '@jetshop/core/hooks/Filters/useFilters';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import get from 'lodash.get';
import qs from 'qs';
import * as React from 'react';
import { Query, useQuery } from 'react-apollo';
const SearchPageBehaviour = props => {
    var _a;
    const pagination = usePagination();
    const { location, searchQuery, children, activeFilters } = props;
    const { offset, perPage } = React.useContext(PaginationContext);
    const activeSearchTerm = React.useRef();
    // Track the previous offset. If it has changed, we're paginating. If it
    // hasn't, we're just applying filters.
    const activeOffset = React.useRef(0);
    const { clearAllFilters } = useFilters();
    throwErrorInDev(!searchQuery, `You did not pass 'searchQuery' to SearchPageBehaviour`);
    const activeFilterQuery = useQuery(ActiveFiltersQuery);
    const searchTerm = React.useMemo(() => qs.parse(location.search, { ignoreQueryPrefix: true }).term, [location]);
    React.useEffect(() => {
        if (activeSearchTerm.current && activeSearchTerm.current !== searchTerm) {
            clearAllFilters();
        }
        activeSearchTerm.current = searchTerm;
    }, [clearAllFilters, searchTerm]);
    React.useEffect(() => {
        activeOffset.current = offset;
    }, [offset]);
    if (pagination === undefined) {
        return (React.createElement(PaginationProvider, null,
            React.createElement(SearchPageBehaviour, Object.assign({}, props))));
    }
    // Ideally this component would use the data from usePagination, but due to
    // how the shouldComponentUpdate method in FilterContainer works it prevents
    // rendering if we don't do it this way.
    return searchTerm ? (React.createElement(Query, { variables: {
            term: searchTerm,
            limit: perPage,
            filters: activeFilters || ((_a = activeFilterQuery.data) === null || _a === void 0 ? void 0 : _a.activeFilters) || null,
            offset: activeOffset.current === offset ? 0 : offset,
            client: !__IN_SERVER__
        }, query: searchQuery, fetchPolicy: "cache-and-network" }, ({ loading, error, data }) => {
        const totalResults = get(data, 'search.products.totalResults');
        const result = get(data, 'search.products.result');
        const filters = get(data, 'search.products.filters');
        return (React.createElement(React.Fragment, null, children({
            result,
            total: totalResults,
            filters,
            term: searchTerm,
            loading,
            error
        })));
    })) : (children({
        term: searchTerm,
        loading: false,
        error: null,
        total: 0,
        result: {},
        filters: {}
    }));
};
const SearchPageBehaviourWrapper = props => {
    const { deprecations: { useOldFilterAPI } } = useShopConfig();
    if (useOldFilterAPI) {
        return (React.createElement(FilterContainerWrapper, Object.assign({}, props), ({ activeFilters }) => (React.createElement(SearchPageBehaviour, Object.assign({}, props, { activeFilters: activeFilters })))));
    }
    else {
        // If using the new filter API, we don't need to render the FilterContainer at all
        return React.createElement(SearchPageBehaviour, Object.assign({}, props));
    }
};
export default SearchPageBehaviourWrapper;
//# sourceMappingURL=SearchPageBehaviour.js.map